<script setup lang="ts">
import type { TOrganizationAsideContacts } from '~/components/widget/organization-aside-contacts'

const { locale } = useI18n()

const route = useRoute()

const props = withDefaults(
  defineProps<{
    organization?: TOrganizationAsideContacts
  }>(),
  {
    organization: () => ({}) as TOrganizationAsideContacts
  }
)

// Allowed route names for showing deposit defense
const depositRoutes = [
  'bank-bank-deposits',
  'bank-deposit',
  'microcredit-deposit',
  'microcredit-microcredit-deposits'
]

const showDepositDefended = computed(() => {
  return (
    props.organization?.options?.deposits_protected &&
    depositRoutes.includes(useCleanRouteName(route.name) as string)
  )
})
</script>

<template>
  <div v-if="showDepositDefended" class="relative space-y-2 border-t pt-4 text-center">
    <NuxtLinkLocale to="deposit-protection-agency" class="flex justify-center">
      <NuxtImg
        class="w-[140px]"
        :src="`/images/azd/deposit-protection_${locale}.png`"
        :alt="$t('widget.deposit_protection.image_alt')"
        format="avif,webp"
        width="140"
        height="124"
      />
    </NuxtLinkLocale>
    <NuxtLinkLocale
      to="deposit-protection-agency"
      class="after:absolute after:inset-0 hover:underline focus-visible:ring-0"
      >{{ $t('widget.deposit_protection.title') }}</NuxtLinkLocale
    >
    <p class="SecondaryTextHeadings">
      {{ $t('widget.deposit_protection.text') }}
    </p>
  </div>
</template>
